import { SET_SOURCE_SETTINGS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCE_SETTINGS_SETTINGS, {
  showConfirm: false,
  loading: false,
  isUpgradePromptActive: false,
  accounts: [],
  collaborators: []
})
